import styled from 'astroturf/react';

const button = styled('button')`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  font-size: var(--ph-text-md);
  color: var(--white);
  background-color: var(--ph-orange-500);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  height: 40px;
  min-width: 40px;
  padding-left: 16px;
  padding-right: 16px;
  border: 0;
  cursor: pointer;
  
  &[type='button']{
    background-color: var(--ph-orange-500);
  }

  &.disabled {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.4;
  }

  &.solid.orange {
    background-color: var(--ph-orange-500);

    &:hover {
      background-color: var(--ph-orange-700);
    }

    &:active {
      background-color: var(--ph-orange-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.ghost.orange {
    background-color: var(--transparent);
    color: var(--ph-orange-500);

    &:hover {
      background-color: var(--ph-orange-25);
      color: var(--ph-orange-700);
    }

    &:active {
      background-color: var(--ph-orange-50);
      color: var(--ph-orange-700);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.outline.orange {
    background-color: var(--transparent);
    border: 2px solid var(--ph-orange-500);
    color: var(--ph-orange-500);

    &:hover {
      background-color: var(--ph-orange-25);
      color: var(--ph-orange-700);
    }

    &:active {
      background-color: var(--ph-orange-50);
      color: var(--ph-orange-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.solid.light-blue {
    background-color: var(--ph-light-blue-500);

    &:hover {
      background-color: var(--ph-light-blue-700);
    }

    &:active {
      background-color: var(--ph-light-blue-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.ghost.light-blue {
    background-color: var(--transparent);
    color: var(--ph-light-blue-500);

    &:hover {
      background-color: var(--ph-light-blue-25);
      color: var(--ph-light-blue-700);
    }

    &:active {
      background-color: var(--ph-light-blue-50);
      color: var(--ph-light-blue-700);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.outline.light-blue {
    background-color: var(--transparent);
    border: 2px solid var(--ph-light-blue-500);
    color: var(--ph-light-blue-500);

    &:hover {
      background-color: var(--ph-light-blue-25);
      color: var(--ph-light-blue-700);
    }

    &:active {
      background-color: var(--ph-light-blue-50);
      color: var(--ph-light-blue-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.solid.red {
    background-color: var(--ph-red-500);

    &:hover {
      background-color: var(--ph-red-700);
    }

    &:active {
      background-color: var(--ph-red-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.ghost.red {
    background-color: var(--transparent);
    color: var(--ph-red-500);

    &:hover {
      background-color: var(--ph-red-25);
      color: var(--ph-red-700);
    }

    &:active {
      background-color: var(--ph-red-50);
      color: var(--ph-red-700);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.outline.red {
    background-color: var(--transparent);
    border: 2px solid var(--ph-red-500);
    color: var(--ph-red-500);

    &:hover {
      background-color: var(--ph-red-25);
      color: var(--ph-red-700);
    }

    &:active {
      background-color: var(--ph-red-50);
      color: var(--ph-red-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.solid.gray {
    background-color: var(--ph-gray-500);

    &:hover {
      background-color: var(--ph-gray-700);
    }

    &:active {
      background-color: var(--ph-gray-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.ghost.gray {
    background-color: var(--transparent);
    color: var(--ph-gray-500);

    &:hover {
      background-color: var(--ph-gray-25);
      color: var(--ph-gray-700);
    }

    &:active {
      background-color: var(--ph-gray-50);
      color: var(--ph-gray-700);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.outline.gray {
    background-color: var(--transparent);
    border: 2px solid var(--ph-gray-500);
    color: var(--ph-gray-500);

    &:hover {
      background-color: var(--ph-gray-25);
      color: var(--ph-red-700);
    }

    &:active {
      background-color: var(--ph-gray-50);
      color: var(--ph-gray-900);
    }

    &:focus {
      box-shadow: var(--ph-box-shadow-focus);
    }
  }

  &.xs {
    font-size: var(--ph-text-xs);
    padding-left: 8px;
    padding-right: 8px;
    height: 24px;
    min-width: 24px;
  }

  &.sm {
    font-size: var(--ph-text-sm);
    padding-left: 12px;
    padding-right: 12px;
    height: 32px;
    min-width: 32px;
  }

  &.md {
    font-size: var(--ph-text-md);
    padding-left: 16px;
    padding-right: 16px;
    height: 40px;
    min-width: 40px;
  }

  &.lg {
    font-size: var(--ph-text-lg);
    padding-left: 24px;
    padding-right: 24px;
    height: 48px;
    min-width: 48px;
  }

  &.xl {
    font-size: var(--ph-text-xl);
    padding-left: 32px;
    padding-right: 32px;
    height: 56px;
    min-width: 56px;
  }

  &.u-float-right {
    float: right;
  }

  &.link {
    color: var(--ph-gray-500);
    background: none;
    padding: 0;
    min-width: auto;
    border-radius: 0;
  }

  &.transparent {
    color: rgba(#332d29, 0.8);
    border: solid 1px var(--ph-gray-50);
    background: transparent;

    &:hover {
      background: var(--ph-gray-50);
    }
  }

  &.gray {
    background: var(--ph-gray-500);
  }

  & + & {
    margin-left: 10px;
  }
`;

const buttonA = styled('a')`
  border-radius: var(--ph-border-radius-sm);
  background-color: var(--ph-orange-500);
  padding: 21px 30px;
  font-size: var(--ph-text-md);
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  color: var(--white);
  border: none;
  outline: none;
  cursor: pointer;

  & + & {
    margin-left: 20px;
  }

  &.sm {
    font-size: var(--ph-text-md);
    line-height: 1.67;
    padding: 10px 21px;
  }

  &.link {
    color: var(--ph-gray-500);
    background: none;
    border-bottom: dotted 1px var(--ph-gray-500);
    padding: 0;
    min-width: auto;
    border-radius: 0;
  }

  &.transparent {
    color: rgba(#332d29, 0.8);
    border: solid 1px var(--ph-gray-50);
    background: transparent;

    &:hover {
      background: var(--ph-gray-50);
    }
  }

  &.gray {
    background: var(--ph-gray-500);
  }

  &:hover {
    color: var(--white);
    text-decoration: none;
  }
`;

const buttonSpan = styled('span')`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  font-size: var(--ph-text-sd);
  color: var(--white);
  background-color: var(--ph-orange-500);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  min-width: 32px;
  border: 0;
  cursor: pointer;

  &.close {
    color: #332d29;
    background: #f2f2f2;
  }

  &.leftMost {
    position: absolute;
    left: 0;
    top: 5px;
  }

  &.forUpdateNote {
    left: 0;
  }

  & + & {
    margin-left: 23px;
  }
`;

export default {
  Button: button,
  ButtonA: buttonA,
  ButtonSpan: buttonSpan,
};
